export const EllipseVerticalIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9" cy="3" r="1.5" stroke="currentColor" />
    <circle cx="9" cy="9" r="1.5" stroke="currentColor" />
    <circle cx="9" cy="15" r="1.5" stroke="currentColor" />
  </svg>
);
